{
  "CallControlMcError": "Ocorreu um erro ao tentar se conectar ao",
  "CallControlActionError": "Ocorreu um erro ao tentar executar a ação",
  "CallControlCompleteTransferError": "Ocorreu um erro ao concluir a transferência",
  "CallControlPickupCallError": "Ocorreu um erro ao atender a chamada",
  "CallControlChangingDndError": "Ocorreu um erro ao alterar o status DND para",
  "CallControlConnectionUpdate": "Ocorreu um erro na atualização da conexão",
  "CallControlDeletePhantom": "Ocorreu um erro ao tentar excluir a chamada fantasma.",
  "CallControlAcdStatusUpdate": "Ocorreu um erro na atualização do status do ACD",
  "CallControlMonitoringActionError": "Ocorreu um erro na ação de monitoramento",
  "CallControlUserInfoMissing": "As informações do usuário estão ausentes. Isso pode indicar que você não está mais autenticado. Tente sair e entrar novamente.",
  "CallControlTelPartDevError": "Servidor de telefonia, Partição, Agente ou Dispositivo não estavam disponíveis.",
  "NAME": "CallControlErrors",
  "CallControlSetAccountCode": "Ocorreu um erro ao tentar definir o código de conta"
}